import { Theme } from '@mui/material';

export const scrollBreakpoint = (theme: Theme) => theme.breakpoints.up('xl');
